import React from 'react';
import FooterLogos from './FooterLogos/FooterLogos';
import FooterMenu from './FooterMenu/FooterMenu';
import FooterCopyright from './FooterCopyright/FooterCopyright';

export default function Footer() {
  return (
    <footer>
      <FooterLogos />
      <FooterMenu />
      <FooterCopyright />
    </footer>
  );
}
